import { Component, HostBinding, ViewEncapsulation } from '@angular/core';

@Component({
    selector: '[jui-menu-group]',
    template: `
        <div class="jui-menu-item-group-title">
            <ng-content select="[title]"></ng-content>
        </div>
        <div class="jui-menu-item-group-list">
            <ng-content></ng-content>
        </div>
    `,
    encapsulation: ViewEncapsulation.None
})
export class MenuGroupComponent {
    @HostBinding('class.jui-menu-item-group') menuItemGroup = true;

    constructor() { }
}
